import { type ReactElement } from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";

import { ProfilePage } from "./Page";
import { UPDATE_EMAIL_PATH, UPDATE_PHONE_PATH, UPDATE_PROFILE_IMAGE_PATH } from "./paths";
import { UpdateEmailPage } from "./UpdateEmail/Page";
import { UpdatePhonePage } from "./UpdatePhone/Page";
import { UpdateProfileImagePage } from "./UpdateProfileImage/Page";

export function ProfileRoutes(): ReactElement {
  const match = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`${match.url}/${UPDATE_EMAIL_PATH}`}>
        <UpdateEmailPage />
      </Route>
      <Route exact path={`${match.url}/${UPDATE_PHONE_PATH}`}>
        <UpdatePhonePage />
      </Route>
      <Route exact path={`${match.url}/${UPDATE_PROFILE_IMAGE_PATH}`}>
        <UpdateProfileImagePage />
      </Route>
      <Route exact path={match.url}>
        <ProfilePage />
      </Route>
    </Switch>
  );
}
